export default __webpack_public_path__ + "static/media/FastBrowsing.38c8c49b.jpeg";